import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { UsersService } from './../../../../../services/API/users/users.service';
import { NotificationServiceService } from './../../../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-user-account',
    templateUrl: './user-account.component.html',
    styleUrls: ['./user-account.component.css'],
    standalone: false
})
export class UserAccountComponent implements OnInit {

  showAdvice: boolean = false;

  userProfileImageSRC = "./../../../../../assets/user_profile.svg";

  userId: number;
  userRol: string = "";
  userActive: string = "";

  datosForm: UntypedFormGroup;
  name: string;
  surname: string;
  email: string;

  passwordForm: UntypedFormGroup;
  password = "********";

  constructor(private fb: UntypedFormBuilder, private usersService: UsersService, private notificationService: NotificationServiceService, public authService: AuthService) { }

  ngOnInit(): void {
    this.datosForm = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
      surname: [this.surname, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
      email: [this.email, [Validators.required, Validators.minLength(1), Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.+[a-zA-Z]{2,4}$")]],
    });
    this.passwordForm = this.fb.group({
      password: [this.password, [Validators.required, Validators.minLength(8), Validators.maxLength(255)]],
    });

    this.datosForm.controls['name'].setValue((localStorage.getItem('appUserName') || ""));
    this.datosForm.controls['surname'].setValue((localStorage.getItem('appUserSurname') || ""));
    this.datosForm.controls['email'].setValue((localStorage.getItem('appUserEmail') || ""));
    this.name = localStorage.getItem('appUserName');
    this.surname = localStorage.getItem('appUserSurname');
    this.email = localStorage.getItem('appUserEmail');
    this.userId = parseInt((localStorage.getItem('appUserID') || "0"));
    this.userRol = (localStorage.getItem('appAuthRol') || "");
    this.userActive = (localStorage.getItem('appUserActive') || "");
  }

  saveUserData() {
    console.log(this.userId);
    if(this.userId > 0){
      var name = this.datosForm.controls['name'].value;
      var surname = this.datosForm.controls['surname'].value;
      var email = this.datosForm.controls['email'].value;
      this.usersService.editUsuarioProfile(this.userId, name, surname, email).subscribe(() => {
        this.notificationService.openSnackBar("¡Usuario modificado correctamente!");
        this.showAdvice = true;
      });
    }
  }

  saveUserPassword() {
    if(this.userId > 0){
      var password = this.passwordForm.controls['password'].value;
      this.usersService.editUsuarioPassword(this.userId, password).subscribe(() => {
        this.notificationService.openSnackBar("¡Contraseña modificada correctamente!");
        this.showAdvice = true;
      });
    }
  }

  logout() {
    this.authService.logout();
  }
}
